import { getPocketBase, escFilter as esc } from '../pocketbase.js';

/** Normalizza opponent_id: stringa non vuota, altrimenti null (Da assegnare). */
export function normalizeOpponentId(raw) {
  if (raw == null) return null;
  const id = String(raw).trim();
  return id || null;
}

export async function fetchAuctionExits(accessKey, auctionId, pbOverride) {
  const pb = pbOverride || getPocketBase();
  if (!auctionId) return [];
  return pb.collection('auction_exits').getFullList({
    filter: `access_key="${esc(accessKey)}" && auction_id="${esc(auctionId)}"`,
  });
}

/**
 * Upsert uscita. `opponentId` opzionale:
 * - undefined in update → non tocca opponent_id (preserva)
 * - null / '' → non assegnato
 * - stringa → id avversario
 */
export async function upsertAuctionExit({
  accessKey,
  auctionId,
  playerKey,
  price,
  opponentId,
}, pbOverride) {
  const pb = pbOverride || getPocketBase();
  const n = Number(price);
  if (!Number.isFinite(n) || n < 1) {
    throw new Error('auction_exits.price deve essere ≥ 1');
  }
  const data = {
    access_key: accessKey,
    auction_id: auctionId,
    player_key: playerKey,
    price: n,
  };
  if (opponentId !== undefined) {
    data.opponent_id = normalizeOpponentId(opponentId);
  }
  const existing = await pb.collection('auction_exits').getFullList({
    filter: `access_key="${esc(accessKey)}" && auction_id="${esc(auctionId)}" && player_key="${esc(playerKey)}"`,
  });
  if (existing.length) {
    const patch = { price: n };
    if (opponentId !== undefined) {
      patch.opponent_id = normalizeOpponentId(opponentId);
    }
    return pb.collection('auction_exits').update(existing[0].id, patch);
  }
  if (data.opponent_id === undefined) {
    data.opponent_id = null;
  }
  return pb.collection('auction_exits').create(data);
}

export async function deleteAuctionExit(accessKey, auctionId, playerKey, pbOverride) {
  const pb = pbOverride || getPocketBase();
  const existing = await pb.collection('auction_exits').getFullList({
    filter: `access_key="${esc(accessKey)}" && auction_id="${esc(auctionId)}" && player_key="${esc(playerKey)}"`,
  });
  for (const r of existing) await pb.collection('auction_exits').delete(r.id);
  return { deleted: existing.length };
}
